import axios from "axios"
import GlobalVariable from "./global"
const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText

const DocusignTitle = 'You have received an email attachment from DocuSign. Please review and sign the document.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Cancelled' }, { value: 3, label: 'Archived' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const fullmonthnames = [
  { key: '01', value: 'Jan' },
  { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' },
  { key: '04', value: 'Apr' },
  { key: '05', value: 'May' },
  { key: '06', value: 'Jun' },
  { key: '07', value: 'Jul' },
  { key: '08', value: 'Aug' },
  { key: '09', value: 'Sep' },
  { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' },
  { key: '12', value: 'Dec' }
]

const addResponseInterceptor = async (axiosInstance) => {
  axiosInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const access_token = error.response.headers['x-auth-token']
      const refresh_token = error.response.headers['x-refresh-token']
      localStorage.setItem("token", access_token)
      localStorage.setItem("refresh_token", refresh_token)
      originalRequest.headers['Authorization'] = `Bearer ${access_token}`
      return axiosInstance(originalRequest)
    }
    return Promise.reject(error)
  })
}

export const DefaultConfig = () => {
  let authAxios
  let authAxiosMulti
  if (localStorage.getItem("userData")) {
    const localStorageToken = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refresh_token')
    authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": refreshToken },
      withCredentials: true
    })
    addResponseInterceptor(authAxios)
    authAxiosMulti = axios.create({
      baseURL: baseApiUrl,
      headers: {
        Authorization: `Bearer ${localStorageToken}`,
        "Content-Type": "multipart/form-data",
        "x-refresh-token": refreshToken
      },
      withCredentials: true

    })
    addResponseInterceptor(authAxiosMulti)
  }

  const sorter = (sortname, sortorder, filteredData) => {
    const sortData = filteredData
    sortData.sort((a, b) => {
      if (sortname === 'recordedDate' || sortname === 'createdDate' || sortname === 'modifiedDate' || sortname === 'startDate' || sortname === 'lastupdatedDate' || sortname === 'approvalDate') {
        if (sortorder === "asc") {
          return (a[sortname] ? new Date(a[sortname]) : a[sortname]) > (b[sortname] ? new Date(b[sortname]) : b[sortname]) ? 1 : (a[sortname] ? new Date(a[sortname]) : a[sortname]) < (b[sortname] ? new Date(b[sortname]) : b[sortname]) ? -1 : 0
        } else {
          return (b[sortname] ? new Date(b[sortname]) : b[sortname]) > (a[sortname] ? new Date(a[sortname]) : a[sortname]) ? 1 : (b[sortname] ? new Date(b[sortname]) : b[sortname]) < (a[sortname] ? new Date(a[sortname]) : a[sortname]) ? -1 : 0
        }
      } else {
        if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
          if (sortorder === "asc") {
            return parseFloat(a[sortname]) > parseFloat(b[sortname]) ? 1 : parseFloat(a[sortname]) < parseFloat(b[sortname]) ? -1 : 0
          } else {
            return parseFloat(b[sortname]) > parseFloat(a[sortname]) ? 1 : parseFloat(b[sortname]) < parseFloat(a[sortname]) ? -1 : 0
          }
        } else if (typeof a[sortname] === "string" && typeof b[sortname] === "string") {
          if (sortorder === "asc") {
            return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
          } else {
            return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
          }
        } else {
          if (sortorder === "asc") {
            return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
          } else {
            return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
          }
        }
      }
    })
    return sortData
  }

  const ReplaceString = (value) => {
    if (value) {
      return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
    }
    return ''
  }

  const DateFormat = (value) => {
    if (value) {
      const monthname = monthnames[new Date(value).getMonth()]
      const datevalue = `0${new Date(value).getDate()}`.slice(-2)
      const yearvalue = new Date(value).getFullYear()
      return `${datevalue}-${monthname}-${yearvalue}`
    } else {
      return ""
    }
  }

  const StringtoDateMonthYearFormat = (valueDate) => {
    if (valueDate) {
      const splitString = valueDate.split("-")
      if (splitString.length === 3) {
        const datevalue = splitString[0]
        const findMonth = fullmonthnames.find(find => find.key === splitString[1])
        let monthname = ''
        if (findMonth) {
          monthname = findMonth.value
        }
        const yearvalue = splitString[2]
        return `${datevalue}-${monthname}-${yearvalue}`
      }
    }
    return ""
  }

  const discountTypes = [
    { id: 1, label: "By Amount", value: "ByAmount" },
    //  { id: 2, value: 2, label: "By Count" },
    { id: 3, value: 3, label: "By Final Price" },
    { id: 4, value: 4, label: "By Percent" }
    // { id: 5, value: 5, label: "By Upto Amount" },
    // { id: 6, value: 6, label: "By From Amount" }
  ]

  const YearMonthDateFormat = (value) => {
    if (value) {
      const date = new Date(value)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ""
  }

  const DateConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ''
  }

  const formattedDateIssueFixed = (data) => {
    if (data) {
      const date = new Date(data)
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      const day = date.getUTCDate()
      const month = months[date.getUTCMonth()]
      const year = date.getUTCFullYear()
      const formattedDate = `${day} ${month} ${year}`
      return formattedDate
    }
  }

  const DateTimeConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)
      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
      const formattedDateTime = `${formattedDate} ${formattedTime}`

      return formattedDateTime
    }
    return ''
  }

  const AmountFormat = (amount) => {
    if (isNaN(amount)) {
      return ''
    }
    let x = Number.parseFloat(amount).toFixed(2)
    const sign = x.startsWith('-') ? '-' : ''
    x = x.replace('-', '')
    const parts = x.split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return sign + parts.join('.')
  }

  const selectStyles = {
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999
    }),
    control: (provided, { isDisabled }) => ({
      ...provided,
      marginTop: 0,
      border: isDisabled ? "1px solid #ccc !important" : provided.border,
      borderRadius: "4px",
      backgroundColor: isDisabled ? "#f2f2f2" : provided.backgroundColor,
      cursor: isDisabled ? "not-allowed" : "pointer"
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "visible"
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
      transition: 'top 0.2s, font-size 0.2s',
      fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
      background: "#fff",
      padding: "0 5px",
      fontWeight: 500,
      color: '#000'
    }),
    multiValue: (base) => ({
      ...base,
      display: "none",
      backgroundColor: "#00acd3",
      borderRadius: "4px",
      display: "none",
      padding: "2px 5px"
    }),
    multiValueLabel: (base) => ({
      ...base,
      width: "60px",
      display: "none",
      color: "#fff",
      fontWeight: "bold",
      fontSize: "14px"
    }),
    multiValueRemove: (base) => ({
      ...base,
      display: "none",
      color: "#fff",
      ":hover": {
        display: "none",
        backgroundColor: "red",
        color: "white"
      }
    })
  }

  const formatYearDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const workDistributions = [
    { id: 1, name: "SALES" },
    { id: 2, name: "RECV" },
    { id: 3, name: "CASH" },
    { id: 4, name: "TAKEN" },
    { id: 5, name: "AVAIL" },
    { id: 6, name: "TRADE" },
    { id: 7, name: "FREIGHT" },
    { id: 8, name: "MISC" },
    { id: 9, name: "TAXES" },
    { id: 10, name: "MARK" },
    { id: 11, name: "COMMEXP" },
    { id: 12, name: "COMMPAY" },
    { id: 13, name: "OTHER" },
    { id: 14, name: "COGS" },
    { id: 15, name: "INV" },
    { id: 16, name: "RETURN" },
    { id: 17, name: "IN USE" },
    { id: 18, name: "IN SERVICE" },
    { id: 19, name: "DAMAGED" },
    { id: 20, name: "UNIT" },
    { id: 21, name: "DEPOSITS" },
    { id: 22, name: "ROUND" },
    { id: 23, name: "REBATE" }
  ]

  const historyDistributions = [
    { id: 1, name: "Cash", code: "CASH" },
    { id: 2, name: "Terms Taken", code: "TAKEN" },
    { id: 3, name: "Accounts Receivable", code: "RECV" },
    { id: 4, name: "Writeoffs", code: "WRITE" },
    { id: 5, name: "Terms Available", code: "AVAIL" },
    { id: 6, name: "GST", code: "GST" },
    { id: 7, name: "PPS", code: "WH" },
    { id: 8, name: "Other", code: "OTHER" },
    { id: 9, name: "Sales", code: "SALES" },
    { id: 10, name: "Trade", code: "TRADE" },
    { id: 11, name: "Freight", code: "FREIGHT" },
    { id: 12, name: "Miscellaneous", code: "MISC" },
    { id: 13, name: "Taxes", code: "TAXES" },
    { id: 14, name: "COGS", code: "COGS" },
    { id: 15, name: "Inventory", code: "INV" },
    { id: 16, name: "Finance Charges", code: "FNCHG" },
    { id: 17, name: "Returns", code: "RETURNS" },
    { id: 18, name: "Debit Memo", code: "DRMEMO" },
    { id: 19, name: "Credit Memo", code: "CRMEMO" },
    { id: 20, name: "Service", code: "SERVICE" },
    { id: 21, name: "Warranty Expense", code: "WARREXP" },
    { id: 22, name: "Warranty Sales", code: "WARRSLS" },
    { id: 23, name: "Commissions Expense", code: "COMMEXP" },
    { id: 24, name: "Commissions Payable", code: "COMMPAY" },
    { id: 25, name: "Unit Account", code: "UNIT" },
    { id: 26, name: "Rounding", code: "ROUND" },
    { id: 27, name: "Realized Gain", code: "RZGAIN" },
    { id: 28, name: "Realized Loss", code: "RZLOSS" },
    { id: 29, name: "Unrealized Gain", code: "URZGAIN" },
    { id: 30, name: "Unrealized Loss", code: "URZLOSS" }
  ]

  const emailDurationTime = 30 * 1000
  const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
  const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
  const CreditCardpercentage = 0.04
  const CreditCardNote = 'Please note that a 4% Convenience Fee is charged based on the transaction total'

  const getTransactionHistoryStatus = [
    { value: 0, label: 'Reserved' },
    { value: 1, label: 'Work' },
    { value: 2, label: 'Open' },
    { value: 3, label: 'History' }
  ]

  const sourceSystem = [{ label: "Seafarer", code: "SFR" }, { label: "WP Cloud", code: "WPC" }, { label: "WayPoint", code: "WP" }, { label: "LIS", code: "LIS" }, { label: "Corporate", code: "CORP" }]

  const getTransactionHistoryInvoiceType = [
    { value: 0, label: 'Reserved for balance carried forward records' }, { value: 1, label: 'Sale / Invoice' },
    { value: 2, label: 'Reserved for scheduled payments' }, { value: 3, label: 'Debit Memo' },
    { value: 4, label: 'Finance Charge' }, { value: 5, label: 'Service / Repair' }, { value: 6, label: 'Warranty' },
    { value: 7, label: 'Credit Memo' }, { value: 8, label: 'Return' }, { value: 9, label: 'Payment' }
  ]

  const getWorkDetailsStatus = [
    { value: 0, label: 'Not Posted' }, { value: 2, label: 'Posted' }, { value: 3, label: 'Error' },
    { value: 7, label: 'Checking ForDuplicate DocumentNumbers' }, { value: 12, label: 'Verifying Accuracy Of Amounts' },
    { value: 14, label: 'Verifying Total Detail Amounts MatchHeader' }, { value: 508, label: 'Transferring Record From SOP10100ToSOP30200' },
    { value: 600, label: 'Validating Detail And Header Records In History' }
  ]

  const getWorkDetailsInvoiceType = [
    { value: 1, label: 'Quote' }, { value: 2, label: 'Order' }, { value: 3, label: 'Invoice' }, { value: 4, label: 'Return' },
    { value: 5, label: 'Back Order' }, { value: 6, label: 'Fulfillment Order' }
  ]

  const DiscountStatus = [
    { value: 1, label: 'Active' }, { value: 2, label: 'IN Active' },
    { value: 3, label: 'Cancelled' },
    { value: 4, label: 'Suspended' }
  ]

  return {
    headerText,
    selectStyles,
    discountTypes,
    DocusignTitle,
    InvoicePaymentModes,
    InvoicePaymentStatus,
    WOStatus,
    sourceSystem,
    errorresponse,
    authAxios,
    authAxiosMulti,
    sorter,
    datesList,
    monthnames,
    DateFormat,
    YearMonthDateFormat,
    AmountFormat,
    StringtoDateMonthYearFormat,
    DateTimeConversion,
    DateConversion,
    ReplaceString,
    emailDurationTime,
    zoomInOut,
    leftToRight,
    formatYearDate,
    CreditCardpercentage,
    CreditCardNote,
    formattedDateIssueFixed,
    getTransactionHistoryStatus,
    getTransactionHistoryInvoiceType,
    getWorkDetailsStatus,
    getWorkDetailsInvoiceType,
    historyDistributions,
    workDistributions,
    DiscountStatus
  }
}
